// Firebase messaging disabled — not needed for country portal deployments.
// Previously initialized Firebase SDK for push notifications, which caused
// crashes on browsers/environments that don't support the Messaging API.

export const foreGroundMessage = () => {
  // no-op: Firebase messaging disabled
};

export const requestForToken = () => {
  // no-op: Firebase messaging disabled
  return Promise.resolve();
};
